"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcPopover = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcPopover = function (props) {
    var text = props.text, _a = props.placement, placement = _a === void 0 ? 'top' : _a, type = props.type, linger = props.linger, dark = props.dark, textCenter = props.textCenter, className = props.className, children = props.children;
    var _b = __read(react_1.useState(), 2), show = _b[0], setShow = _b[1];
    var _c = __read(react_1.useState(null), 2), target = _c[0], setTarget = _c[1];
    var _d = __read(react_1.useState(), 2), timerId = _d[0], setTimerId = _d[1];
    var ref = react_1.useRef(null);
    var handleEnter = function (event) {
        setTarget(event.target);
        setShow(true);
        clearTimeout(timerId);
    };
    var handleLeave = function (event) {
        if (linger) {
            var timerId_1 = setTimeout(function () {
                setTarget(null);
                setShow(false);
            }, 1500);
            setTimerId(timerId_1);
        }
        else {
            setTarget(null);
            setShow(false);
        }
    };
    var handleCancel = function () {
        setTarget(null);
        setShow(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: className, onMouseEnter: handleEnter, onMouseLeave: handleLeave, onClick: handleCancel },
            react_1.default.createElement("span", { ref: ref }),
            children),
        react_1.default.createElement(react_bootstrap_1.Overlay, { show: show, target: target, container: ref.current, containerPadding: 20, placement: placement },
            react_1.default.createElement(react_bootstrap_1.Popover, { className: (dark ? 'popover-dark' : '') + " " + (type === 'error' ? 'popover-error' : '') + " " + (textCenter ? 'text-center' : ''), id: "acpopover" },
                react_1.default.createElement(react_bootstrap_1.Popover.Content, null, text)))));
};
exports.AcPopover = AcPopover;
exports.AcPopover.displayName = 'AcPopover';
//# sourceMappingURL=AcPopover.js.map